import React from 'react'

import { Box, Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import WarningIcon from '@material-ui/icons/Warning'
import { Alert } from '@material-ui/lab'

import { useBrand } from '~/brand'
import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'
import { isValidEmail } from '~/customer/helpers/customer.helpers'

const useStyles = makeStyles(() => {
  return {
    changeEmailTypography: {
      textTransform: 'capitalize',
    },
  }
})
export interface AddEnergyContractProps {
  customerDocumentValue: string
  customerEmail: string
  onClose: () => void
  nextStep: () => void
}

const AddEnergyContract: React.FC<AddEnergyContractProps> = ({
  customerDocumentValue,
  customerEmail,
  nextStep,
  onClose,
}) => {
  const { runtimeConfig } = useAppDepsContext()
  const { brand } = useBrand()
  const classes = useStyles()

  const handleAddEnergyContract = () => {
    onClose()
    window.open(
      `${runtimeConfig.energyHost}/signups/new?fiscalid=${customerDocumentValue}&auth_schema=auth-${brand}`,
      '_blank',
    )
  }

  return (
    <Box data-hook="add-energy-contract">
      <Box my={6}>
        <Typography variant="body1" color="textSecondary">
          Antes de realizar la venta de energía es imprescindible verificar que el email es válido.
          Si no es así, por favor modifícalo antes de continuar:
        </Typography>
      </Box>
      <Box width="100%" display="flex" alignItems="center" pb={8}>
        <Alert data-hook="customer-email-alert" severity="info" icon={<WarningIcon />}>
          {`Email actual: ${customerEmail}`}
        </Alert>
        <Box px={6}>
          <Button data-hook="change-email-button" onClick={() => nextStep()}>
            <Typography className={`${classes.changeEmailTypography} link`} variant="body2">
              Modificar
            </Typography>
          </Button>
        </Box>
      </Box>
      <Box py={8} display="flex">
        <Box mr={6}>
          <Button
            variant="contained"
            color="secondary"
            disabled={!isValidEmail(customerEmail)}
            onClick={() => handleAddEnergyContract()}
          >
            Continuar
          </Button>
        </Box>
        <Button variant="outlined" color="secondary" onClick={() => onClose()}>
          Cancelar
        </Button>
      </Box>
    </Box>
  )
}

export default AddEnergyContract
